import { ILocationPromoCodes } from './LocationPromoCodesState';

export const cachedPromoCodes = {} as ILocationPromoCodes;
